import {
  actions,
  getBusinessGroupUserDatatableAsync,
  createNewBusinessGroupUserAsync,
  setBusinessGroupUserRoleAsync,
  getBusinessGroupUserDatatableExportedAsync,
  unlinkBusinessGroupUserAsync,
  createNewBusinessGroupAdminAsync,
} from './slices';

export const BusinessUsersActions = {
  ...actions,
  getBusinessGroupUserDatatableAsync,
  createNewBusinessGroupUserAsync,
  setBusinessGroupUserRoleAsync,
  getBusinessGroupUserDatatableExportedAsync,
  unlinkBusinessGroupUserAsync,
  createNewBusinessGroupAdminAsync,
};
